import type { AppUser } from "~~/types/user";

export default defineNuxtRouteMiddleware(async (to) => {
    const { user, loading, getUser } = useAuthUser();
    const localePath = useLocalePath();

    if (user.value === null) {
        await getUser();
    }

    const loginPath = localePath("/auth/login");
    const path = to.path.replace(/^\/(en|ru)(?=\/)/, "");

    if (path.startsWith("/dashboard") && !user.value) {
        return navigateTo(loginPath);
    }
});